<template>
  <ElTable
    :data="data"
    row-key="token"
    cell-class-name="alpha-table__cell"
    class="alpha-table"
  >
    <ElTableColumn min-width="100" :label="$t('MOBILE_PHONE')">
      <template slot-scope="{ row: { phoneNumber } }">
        {{ phoneNumber }}
      </template>
    </ElTableColumn>
    <ElTableColumn min-width="100" :label="$t('INVITED_TIME')">
      <template slot-scope="{ row: { dateJoined } }">
        {{ dateJoined }}
      </template>
    </ElTableColumn>
    <ElTableColumn max-width="10">
      <template slot-scope="{ row: { phoneNumber } }">
        <div class="alpha-table__actions">
          <ElTooltip
            :disabled="data.length > 1"
            :content="$t('GROUP_MIN_MEMBER_REQUIRED')"
            placement="top"
          >
            <ElButton
              type="danger"
              :plain="true"
              size="mini"
              icon="el-icon-delete"
              class="alpha-table__delete-btn"
              :disabled="data.length <= 1"
              @click="deleteMember(phoneNumber)"
            />
          </ElTooltip>
        </div>
      </template>
    </ElTableColumn>
  </ElTable>
</template>

<script>
export default {
  name: 'AlphaDetailTable',
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  methods: {
    deleteMember(phoneNumber) {
      this.$emit('delete', phoneNumber);
    },
  },
};
</script>

<style lang="scss">
.alpha-table {
  &__cell {
    border-bottom: 0 !important;
  }

  &__button {
    margin-left: calc($global-margin / 2) !important;

    @include rtl() {
      margin-left: 0 !important;
      margin-right: calc($global-margin / 2);
    }
  }

  &__edit.is-disabled,
  &__edit.is-disabled:hover {
    color: color.scale($lb-lighter-gray, $lightness: -20%) !important;
    border-color: color.scale($lb-lighter-gray, $lightness: -20%) !important;
    background: transparent !important;
  }

  @include breakpoint(medium down) {
    &__edit > span {
      display: none;
    }
  }

  .el-table {
    &__row {
      cursor: pointer;
      transition: background-color 0.2s ease;
      &:hover {
        background-color: #f5f7fa;
      }
      &--no-expand .el-table__expand-icon {
        display: none;
      }

      &.expanded {
        background: $--background-color-base;
      }
    }

    &__auto-publish.el-switch__label span {
      font-size: rem-calc(11);
      margin-right: $global-margin;
    }

    &__expanded-cell {
      padding: 0 !important;
    }
  }
}
</style>
